export default __webpack_public_path__ + "images/FJ.a449370.png";